// melasma.ts

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string;
        type?: string;
        title?: string;
        description?: string;
        url?: string;
        site_name?: string;
        updated_time?: string;
        image?: string;
        image_secure_url?: string;
        image_width?: number;
        image_height?: number;
        image_alt?: string;
        image_type?: string;
        video?: string;
        video_duration?: number;
        video_upload_date?: string;
        video_allow_embed?: boolean;
    };
    twitter?: {
        card?: string;
        title?: string;
        description?: string;
        image?: string;
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    treatmentAreas1: TreatmentArea[];
    treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string;
        beforeAfter: string[];
        introductionImage?: string;
    };
    product: {
        id: number;
        title: string;
        price: number;
        description: string;
    };
}

export const melasma: {
    en: LanguageContent;
    ar: LanguageContent;
    shared: SharedData;
} =
{
    "en": {
        "url": "",
        "meta": {
            "title": "Melasma Treatment Dubai -",
            "description": "Melasma, is a skin darkening condition that mostly affects people who spend time in the sun or live in tropical regions. Mainly young women get affected with",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/services/melasma-treatment-dubai/",
            "og": {
                "locale": "en_US",
                "type": "article",
                "title": "Melasma Treatment Dubai -",
                "description": "Melasma, is a skin darkening condition that mostly affects people who spend time in the sun or live in tropical regions. Mainly young women get affected with",
                "url": "https://elitebodyhome.com/services/melasma-treatment-dubai/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-03-11T08:32:36+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/New-Service-Banner-Image-1-1-scaled.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/New-Service-Banner-Image-1-1-scaled.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "Ear Piercing Dubai",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "Melasma Treatment Dubai -",
                "description": "Melasma, is a skin darkening condition that mostly affects people who spend time in the sun or live in tropical regions. Mainly young women get affected with",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/New-Service-Banner-Image-1-1-scaled.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Melasma Treatment Dubai"],
        "hero": {
            "title": "Melasma Treatment Dubai",
            "subtitle": "Achieve Super Clear, Radiant Skin with Melasma",
            "description": "Melasma is a darkening of the skin condition that predominantly occurs in sun-exposed areas, and or the tropical population. Melasma is seen in mainly Young Women starts to get affected as Melasma is much related to Female harmones Progesterone and Estrogen. Melasma treatment in Dubai at Elite Body Home is one of the best treatment to get control over melasma. Bleach pigmentation, discolorations and dark patches. Our high-quality specialists offer the best Melasma treatment according to your requirements."
        },
        "howItWorks": {
            "title": "What IS Melasma: The Basics You Should Know.",
            "description": "Melasma is a condition in which the skin darkens, predominantly on the face, producing brown or tan patches on the chin, forehead, nose, and cheeks. It is usually worsened by exposure to direct sunlight. At Elite Body Home we provide the latest benefits to heal and restore balance and clarity to your skin."
        },
        "procedureSteps": {
            "heading": "Steps for Melasma Treatment",
            "para": "Because melasma is not a one-size-fits-all skin concern, it requires personalized treatment for the best results. From initial consultation to treatment, every step is tailored to focus on pigmentation, delivering both comfort and efficacy to create a beautiful, uniform skin tone. Here’s what you can expect:",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "The first step gives the dermatalogist full understanding of your skin conditon and a complete plan to be achieved.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "Preparation",
                    "desc": "In this step cleaning of area where procedure need to be performed and apply anesthic if necessary.",
                    "icon": "fa-solid fa-broom"
                },
                {
                    "title": "Treatment",
                    "desc": "Now comes the treatment part. Here are some treatment options available for Melasma in Dubai. It includes: Microdermabrasion, Chemical Peel, Laser Treatment, Tropical Method. These processes helps to bring out the melanil out and provide a whitish skin.",
                    "icon": "fa-solid fa-hand-holding-medical"
                },
                {
                    "title": "Session Duration",
                    "desc": "The treatment itself varies between 30–45 minutes depending on the treatment chosen or areas treated.",
                    "icon": "fa-regular fa-clock"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits of Melasma Treatment",
            "subheading": "",
            "para": "However, this kind of melasma treatement at Elite Body Home is the one that gives you all these best pros.. Bye bye for the more darker skin. Besides, change your skin tone to make it even more beautiful.",
            "items": [
                {
                    "title": "Skin Tone Improvement",
                    "desc": "This is the immediate results after a melasma treatment.",
                    "icon": "fa-solid fa-face-grin-stars"
                },
                {
                    "title": "Painless",
                    "desc": "They are pain free and almost non invasive procedures.",
                    "icon": "fa-solid fa-thumbs-up"
                },
                {
                    "title": "No Side Effects",
                    "desc": "If you know how to care for yourself post-op, there won’t be any side effects.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "Worthy Results",
                    "desc": "It takes many sessions to achieve the desired clear skin tone. But the results are worth it.",
                    "icon": "fa-solid fa-award"
                }
            ]
        },
        "eligibility": {
            "heading": "Treatment for Melasma: Is It For You?",
            "subheading": "",
            "para": "What are those brown spots on cheecks or nose? A perfect combination for Candidates who are fed up from these dark spots, pigmentation or discolorations. If you meet the following criteria, then the Melasma treatment in Dubai is a perfect option for you:",
            "items": [
                {
                    "title": "Worried about skin discoloration due to melasma.",
                    "desc": "",
                    "icon": "fa-solid fa-circle-exclamation"
                },
                {
                    "title": "The goal is to eradicate the hyperpigmentation completely.",
                    "desc": "",
                    "icon": "fa-solid fa-bullseye"
                },
                {
                    "title": "Anyone who wants to improve the skin tone.",
                    "desc": "",
                    "icon": "fa-solid fa-face-smile"
                },
                {
                    "title": "Which stimulates any future pigmentation risk to your skin.",
                    "desc": "",
                    "icon": "fa-solid fa-shield-halved"
                },
                {
                    "title": "You do not want things of a surgical nature done",
                    "desc": "",
                    "icon": "fa-solid fa-scissors"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparation",
            "subheading": "",
            "para": "",
            "items": [
                {
                    "title": "Avoid alcohol and blood vessels:",
                    "desc": "Avoid alcohol or any blood-thinning medications for at least 24 hours before the procedure, because these can increase bleeding.",
                    "icon": "fa-solid fa-wine-glass-empty"
                },
                {
                    "title": "Clean your ears:",
                    "desc": "Use a mild soap and water to gently wash your outer ears before your appointment to make sure they are free from dust or debris.",
                    "icon": "fa-solid fa-soap"
                },
                {
                    "title": "Stay hydrated:",
                    "desc": "Staying hydrated before undergoing a piercing can also make the experience easier.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Opt For Hypo-Allergenic Earrings:",
                    "desc": "For individuals with metal allergies, make sure to use hypoallergenic earrings.",
                    "icon": "fa-solid fa-allergies"
                },
                {
                    "title": "Do not use cream or lotion:",
                    "desc": "Do not use any creams, lotions, or oils on your ears the day you are pierced.",
                    "icon": "fa-solid fa-bottle-droplet"
                }
            ]
        },
        "results": {
            "heading": "Enjoy Outstanding Results with Melasma Treatment in Dubai",
            "subheading": "",
            "para": "Advanced Soothe & Glow Facial Take home Naturally Glowing & Clear Skin!! Because it’s a non-invasive solution, you can return to your work immediately.",
            "items": [
                {
                    "title": "Clear & Enhanced Skin Tone",
                    "desc": "Brightening the entire complexion without long treatments.",
                    "icon": "fa-solid fa-sun"
                },
                {
                    "title": "Self-confidence building",
                    "desc": "Be different and stylish at the same time. Establish a high level of assurance. Greater pigmentation lowers the complexion level.",
                    "icon": "fa-solid fa-heart"
                }
            ]
        },
        "aftercareTips": {
            "heading": "Aftercare Tip: Lighten Up Your Skin.",
            "subheading": "",
            "para": "No matter the aftercare is essential in the little treat. In the same manner, adhering to a correct routine will assist you in optimizing and getting the most effective outcomes.",
            "items": [
                {
                    "title": "Topical Medications",
                    "desc": "Once procedure is done, apply a topical medication to lessen the side effects.",
                    "icon": "fa-solid fa-prescription-bottle-medical"
                },
                {
                    "title": "Maintain Moisture",
                    "desc": "Indeed, according to those who have studied the impact of these bumps on the skin, it is considered these do not touch the skin — so keep the area moist, and avoid touching it — do not touch! Neither should you runb or massage your skin.",
                    "icon": "fa-solid fa-hand-holding-droplet"
                },
                {
                    "title": "Avoid Sun Exposure",
                    "desc": "P stay out of the sun for a couple of weeks post treatment. And if you are going outside, always put sunscreen on",
                    "icon": "fa-solid fa-sun-plant-wilt"
                }
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "Can I permanently cure Melasma?",
                    "answer": "You cannot cure Melasma permanently. However, treatments are generally made to reduce dark patches and spots caused in the regard of melasma."
                },
                {
                    "question": "Is there any deficiency that causes Melasma?",
                    "answer": "Yes! It’s associated with Vitamin B12 deficiency, also known as pernicious anemia."
                },
                {
                    "question": "When I can see the results after Melasma treatment in Dubai?",
                    "answer": "You get to see the improvement in the skin generally after 2-4 weeks. Further, it also depends on the skin type and the treatment opted."
                },
                {
                    "question": "Is melasma treatment safe for all skin types?",
                    "answer": "Yes! It is ideal for all types of skin tones. We at Elite Body Home offer the right consultation and recommend the best treatment plan for you."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    },
    "shared": {
        "images": {
            "introductionImage": "",
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/New-Service-Banner-Image-1-1-scaled.jpg",
            "beforeAfter": [
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/11/Melasma-Treatment-Dubai-EBH-1.jpg",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/11/Melasma-Treatment-Dubai-EBH-2.jpg",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/11/Melasma-Treatment-Dubai-EBH-3.jpg"
            ]
        },
        "product": {
            "id": 103,
            "title": "Melasma Treatment Package",
            "price": 450,
            "description": "Comprehensive melasma treatment designed to reduce skin darkening caused by sun exposure, with customized solutions for young women in tropical climates."
        }
    },

    "ar": {
        "url": "",
        "meta": {
            "title": "علاج الكلف في دبي - استعادة بشرة نقية ومشرقة",
            "description": "علاج الكلف في دبي مع ايليت بودي هوم. تخلص من التصبغات والبقع الداكنة باستخدام أحدث التقنيات. استشارة مجانية مع أخصائيي الجلدية لدينا.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/services/melasma-treatment-dubai/",
            "og": {
                "locale": "ar_AR",
                "type": "article",
                "title": "علاج الكلف في دبي - استعادة بشرة نقية ومشرقة",
                "description": "علاج الكلف في دبي مع ايليت بودي هوم. تخلص من التصبغات والبقع الداكنة باستخدام أحدث التقنيات. استشارة مجانية مع أخصائيي الجلدية لدينا.",
                "url": "https://elitebodyhome.com/services/melasma-treatment-dubai/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-03-11T08:32:36+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/New-Service-Banner-Image-1-1-scaled.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/New-Service-Banner-Image-1-1-scaled.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "علاج الكلف في دبي",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "علاج الكلف في دبي - استعادة بشرة نقية ومشرقة",
                "description": "علاج الكلف في دبي مع ايليت بودي هوم. تخلص من التصبغات والبقع الداكنة باستخدام أحدث التقنيات. استشارة مجانية مع أخصائيي الجلدية لدينا.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/New-Service-Banner-Image-1-1-scaled.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "علاج الكلف في دبي"],
        "hero": {
            "title": "علاج الكلف في دبي",
            "subtitle": "للحصول على بشرة نقية ومشرقة",
            "description": "الكلف هو حالة تصبغ جلدي تؤدي إلى اسمرار البشرة، وتُصيب عادةً الأشخاص الذين يتعرضون للشمس لفترات طويلة أو يعيشون في المناطق الاستوائية -وخاصة النساء- حيث يرتبط بالهرمونات الأنثوية (الأستروجين والبروجستيرون). فإذا كنت تبحث عن حل فعال للتحكم في الكلف، فإن علاج الكلف في دبي مع ايليت بودي هوم هو الخيار الأمثل. تخلص من التصبغات والبقع الداكنة، وتوحيد لون البشرة مع فريق من أمهر المتخصصين، الذين يقدمون أفضل العلاجات المُصممة خصيصًا لتلبية احتياجاتك الفريدة."
        },
        "howItWorks": {
            "title": "تعريف الكلف: ما هو؟",
            "description": "الكلف هو حالة تؤدي إلى اسمرار الجلد - خاصة في الوجه - حيث تظهر بقع بنية أو داكنة على الذقن، والجبهة، والأنف، والخدين. وقد يؤدي التعرض المباشر لأشعة الشمس إلى تفاقم المشكلة في معظم الحالات. نقدم في ايليت بودي هوم أحدث العلاجات المتطورة للتخلص من تلك التصبغات، واستعادة توازن البشرة ونقائها."
        },
        "procedureSteps": {
            "heading": "خطوات علاج الكلف",
            "para": "يجب اتباع طرق مُخصصة تلائم حالة البشرة وتضمن الحصول على أفضل النتائج، حيث صُممت كل خطوة في عملية العلاج بعناية لاستهداف التصبغات مع الحفاظ على الراحة والأمان، مما يساعد في الحصول على بشرة موحدة اللون ومشرقة.",
            "steps": [
                {
                    "title": "الاستشارة",
                    "desc": "يُقيّم أخصائي الأمراض الجلدية حالة البشرة بدقة، ويُحدد خطة علاجية ملائمة وفقًا لاحتياجاتك.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "الاستعداد",
                    "desc": "تُنظف البشرة بعناية ويمكن استخدام مخدر موضعي إذا لزم الأمر، وذلك لضمان راحة المريض أثناء الإجراء.",
                    "icon": "fa-solid fa-broom"
                },
                {
                    "title": "العلاج",
                    "desc": "تُنفذ خطة العلاج المناسبة، حيث تتوفر عدة خيارات متطورة لعلاج الكلف في دبي، ومنها: المايكروديرمابريجن (تقشير الجلد الدقيق)، التقشير الكيميائي، العلاج بالليزر، العلاج الموضعي. تساعد هذه العلاجات في التخلص من الميلانين الزائد للحصول على بشرة موحدة اللون وأكثر نقاءً.",
                    "icon": "fa-solid fa-hand-holding-medical"
                },
                {
                    "title": "مدة الجلسة",
                    "desc": "تستغرق جلسة العلاج من 30 إلى 45 دقيقة عادةً، وذلك حسب نوع العلاج المحدد والمنطقة المستهدفة.",
                    "icon": "fa-regular fa-clock"
                }
            ]
        },
        "benefits": {
            "heading": "فوائد علاج الكلف",
            "subheading": "",
            "para": "نقدم لك جميع المميزات الاستثنائية عند اختيارك لعلاج الكلف في ايليت بودي هوم. ودّع البشرة الداكنة وتمتع بإطلالة مشرقة وجميلة!",
            "items": [
                {
                    "title": "توحيد لون البشرة",
                    "desc": "ستلاحظ تغيرًا فوريًا في لون البشرة بعد الخضوع للعلاج.",
                    "icon": "fa-solid fa-face-grin-stars"
                },
                {
                    "title": "خالي من الألم",
                    "desc": "نوفر علاجات غير مؤلمة وغير جراحية فعليّاً.",
                    "icon": "fa-solid fa-thumbs-up"
                },
                {
                    "title": "لا تسبب آثار جانبية",
                    "desc": "لا تظهر آثار جانبية عند اتباع الإرشادات الصحيحة بعد العلاج.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "نتائج فعالة",
                    "desc": "سيتطلب عدة جلسات للحصول على بشرة صافية تمامًا، إلا أن النتائج مُرضية للغاية.",
                    "icon": "fa-solid fa-award"
                }
            ]
        },
        "eligibility": {
            "heading": "الأهلية",
            "subheading": "",
            "para": "هل علاج الكلف مناسب لك؟ إذا كنت تعانين من البقع البنية الداكنة على الخدين أو الأنف المعروفة بالكلف، فلا داعي للقلق، سيكون علاج الكلف في دبي هو الحل الأمثل لك.",
            "items": [
                {
                    "title": "إذا كنت قلق بشأن تغير لون البشرة الناتج عن الكلف.",
                    "desc": "",
                    "icon": "fa-solid fa-circle-exclamation"
                },
                {
                    "title": "إذا كنت ترغب في التخلص من فرط التصبغ نهائيًا.",
                    "desc": "",
                    "icon": "fa-solid fa-bullseye"
                },
                {
                    "title": "إذا كنت ترغب في تحسين لون البشرة وجعلها أكثر إشراقًا.",
                    "desc": "",
                    "icon": "fa-solid fa-face-smile"
                },
                {
                    "title": "إذا كنت تبحث عن طريقة للتخفيف من خطر التصبغات المستقبلية.",
                    "desc": "",
                    "icon": "fa-solid fa-shield-halved"
                },
                {
                    "title": "إذا كنت لا ترغب في الخضوع إلى إجراء جراحي.",
                    "desc": "",
                    "icon": "fa-solid fa-scissors"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد للعلاج",
            "subheading": "",
            "para": "",
            "items": [
                {
                    "title": "تجنب الكحول والأدوية المميعة للدم",
                    "desc": "تجنب الكحول أو أي أدوية مميعة للدم لمدة 24 ساعة على الأقل قبل الإجراء، لأنها قد تزيد من النزيف.",
                    "icon": "fa-solid fa-wine-glass-empty"
                },
                {
                    "title": "تنظيف البشرة",
                    "desc": "استخدم صابونًا لطيفًا وماءً لتنظيف بشرتك قبل الموعد للتأكد من خلوها من الأتربة أو الشوائب.",
                    "icon": "fa-solid fa-soap"
                },
                {
                    "title": "الحفاظ على الترطيب",
                    "desc": "يساعد شرب الماء بكميات كافية قبل الجلسة على تسهيل العملية.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "اختيار مواد غير مسببة للحساسية",
                    "desc": "بالنسبة للأشخاص الذين يعانون من حساسية المعادن، يجب استخدام مواد غير مسببة للحساسية.",
                    "icon": "fa-solid fa-allergies"
                },
                {
                    "title": "تجنب الكريمات والمرطبات",
                    "desc": "لا تستخدم أي كريمات أو مرطبات أو زيوت على بشرتك في يوم العلاج.",
                    "icon": "fa-solid fa-bottle-droplet"
                }
            ]
        },
        "results": {
            "heading": "استمتع بنتائج مذهلة مع علاج الكلف في دبي",
            "subheading": "",
            "para": "الحصول على بشرة مشرقة ونقية طبيعيًا، كما يمكنك العودة إلى العمل فورًا بعد الجلسة نظرًا لكونه إجراء غير جراحي.",
            "items": [
                {
                    "title": "الحصول على لون بشرة موحد ومشرق",
                    "desc": "يساعد العلاج في تحسين وتفتيح لون البشرة دون الحاجة إلى إجراءات طويلة أو معقدة.",
                    "icon": "fa-solid fa-sun"
                },
                {
                    "title": "تعزيز الثقة بالنفس",
                    "desc": "يساعد علاج التصبغات في توحيد لون البشرة، مما يزيد من تألقها ويعزز ثقتك بنفسك. تميّز بإطلالة رائعة وجذابة!",
                    "icon": "fa-solid fa-heart"
                }
            ]
        },
        "aftercareTips": {
            "heading": "نصائح للعناية بعد العلاج: احصل على بشرة أكثر إشراقًا.",
            "subheading": "",
            "para": "تعد العناية بالبشرة بعد العلاج ضرورية حتى في أبسط الإجراءات، حيث يساعد اتباع جدول رعاية مناسب في تحقيق أفضل النتائج الممكنة.",
            "items": [
                {
                    "title": "استخدام العلاجات الموضعية",
                    "desc": "يُفضل استخدام الأدوية الموضعية الموصوفة بعد الإجراء لتخفيف من الآثار جانبية.",
                    "icon": "fa-solid fa-prescription-bottle-medical"
                },
                {
                    "title": "الحفاظ على ترطيب البشرة",
                    "desc": "حافظ على رطوبة المنطقة المُعالجة، وتجنب فركها أو تدليكها.",
                    "icon": "fa-solid fa-hand-holding-droplet"
                },
                {
                    "title": "تجنب التعرض لأشعة الشمس",
                    "desc": "تجنب تعرض بشرتك للشمس لعدة أسابيع بعد العلاج. واحرص على استخدام واقي الشمس لحماية البشرة عند الحاجة للخروج.",
                    "icon": "fa-solid fa-sun-plant-wilt"
                }
            ]
        },
        "faqData": {
            "heading": "أسئلة متكررة",
            "subheading": "",
            "items": [
                {
                    "question": "هل يمكن علاج الكلف نهائيًا؟",
                    "answer": "لا يمكن علاج الكلف بشكل نهائي، ولكن العلاجات المتاحة تعمل على تخفيف البقع الداكنة والتصبغات بشكل فعال."
                },
                {
                    "question": "هل يتسبب نقص أحد العناصر الغذائية في ظهور الكلف؟",
                    "answer": "نعم، يرتبط الكلف بنقص فيتامين B12، ويعرف بفقر الدم الخبيث."
                },
                {
                    "question": "متى يمكنني رؤية نتائج علاج الكلف في دبي؟",
                    "answer": "تظهر نتائج العلاج خلال 2-4 أسابيع عادةً، ولكن يعتمد ذلك على نوع البشرة ونوع العلاج المستخدم."
                },
                {
                    "question": "هل علاج الكلف آمن لجميع أنواع البشرة؟",
                    "answer": "نعم، يناسب العلاج جميع درجات وأنواع البشرة. ويُسعدنا تقديم لك الاستشارة المناسبة في ايليت بودي هوم وتحديد أفضل خطة علاجية وفقًا لاحتياجات بشرتك."
                },
                {
                    "question": "ما مدة دوام نتائج العلاج؟",
                    "answer": "إذا التزمت بإرشادات العناية بعد العلاج واستخدام واقي الشمس، فقد تدوم النتائج لفترة طويلة ويمكنك الاستمتاع بنتائج رائعة مع تخفيف خطر عودة التصبغات."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    }

};
